import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getUser } from "../../redux/Action";
import { useDispatch } from "react-redux";
import Footer from "./Footer";

const Home = () => {
  const location = useLocation();
  const query = location?.search?.substring(1);
  const dispatch = useDispatch();

  useEffect(() => {
    if (query?.length > 1) {
      localStorage.setItem("jwtoken", query);
      getUser(dispatch);
    }
    document.title = "Blogshog | Digital Architecture";
  }, [query, dispatch]);

  return (
    <main className="min-h-screen bg-white dark:bg-black text-black dark:text-white font-sans selection:bg-red-600 selection:text-white mt-[73px]">
      {/* MASSIVE TYPOGRAPHY & FLOATING CARDS HERO */}
      <section className="relative w-full overflow-hidden bg-white dark:bg-black pb-10">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#00000010_1px,transparent_1px),linear-gradient(to_bottom,#00000010_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#ffffff20_1px,transparent_1px),linear-gradient(to_bottom,#ffffff20_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>
        <div className="relative z-10 w-full flex flex-col items-center justify-center min-h-[85vh] py-20 px-4">
          <h1 className="text-[14vw] leading-[0.8] font-black uppercase tracking-tighter text-center mix-blend-difference dark:mix-blend-normal z-20 pointer-events-none w-[110%] whitespace-nowrap text-black dark:text-white drop-shadow-lg">
            DIGITAL
            <br />
            ARCHITECTURE
          </h1>

          {/* Floating Cards (Absolute positioned) */}
          <div className="absolute top-[8%] left-[5%] md:left-[10%] w-[35vw] min-w-[180px] aspect-[2/3] sm:aspect-[4/5] max-w-[380px] rotate-[-7deg] border-2 border-black dark:border-white p-2 bg-white dark:bg-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)] z-0 transition-transform duration-500 hover:scale-[1.04] hover:rotate-[-2deg]">
            <img
              src="https://images.unsplash.com/photo-1731927148727-1db64194b951?q=80&w=627&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              className="w-full h-full object-cover grayscale hover:grayscale-0 contrast-125 border border-black dark:border-white/30"
              alt="Architecture"
            />
            <div className="absolute top-4 left-4 bg-white dark:bg-black text-black dark:text-white border border-black dark:border-white/30 px-2 py-1 text-[8px] font-mono font-bold uppercase shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
              FIG. 01
            </div>
          </div>

          <div className="absolute bottom-[5%] right-[5%] md:right-[15%] w-[30vw] min-w-[200px] aspect-[4/3.5] sm:aspect-[3/4] max-w-[350px] rotate-[5deg] border-2 border-black dark:border-white p-2 bg-white dark:bg-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)] z-20 hover:z-30 transition-transform duration-500 hover:scale-[1.04] hover:rotate-[2deg]">
            <img
              src="https://images.unsplash.com/photo-1457369804613-52c61a468e7d?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              className="w-full h-full object-cover grayscale hover:grayscale-0 contrast-125 brightness-90 border border-black dark:border-white/30"
              alt="Details"
            />
            <Link
              to="/blogs"
              className="absolute inset-0 flex items-center justify-center group"
            >
              <div className="w-28 h-28 rounded-none border border-black dark:border-white/30 bg-[#f4f4f4] dark:bg-[#111] flex flex-col items-center justify-center text-xs font-black uppercase tracking-widest text-center shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] group-hover:bg-black group-hover:text-white dark:group-hover:bg-white dark:group-hover:text-black transition-all transform group-hover:scale-110">
                START
                <br />
                READING
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* HORIZONTAL GRID SECTION */}
      {/* <section className="flex flex-col lg:flex-row border-b border-black dark:border-white/30 bg-white dark:bg-black relative z-20">
        <FeatureGridItem title="Interface Design" link="/blogs" />
        <FeatureGridItem title="Creative Direction" link="/blogs" />
        <FeatureGridItem title="Motion Identity" link="/blogs" />
      </section> */}

      {/* MANIFESTO AND PHILOSOPHY BLOCK */}
      <section className="flex flex-col md:flex-row border-y border-black dark:border-white/30 min-h-[50vh] bg-white dark:bg-black my-10">
        {/* Left Side */}
        <div className="w-full md:w-1/4 border-b md:border-b-0 md:border-r border-black dark:border-white/30 p-8 flex flex-col justify-between">
          <span className="text-xs font-mono uppercase font-black tracking-widest text-black dark:text-white bg-[#f4f4f4] dark:bg-[#111] px-4 py-2 border border-black dark:border-white/30 inline-block shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
            Create Stunning Blogs
          </span>
          <div className="mt-16 text-[10px] font-mono uppercase flex flex-col gap-2">
            <div className="flex items-center gap-2 font-bold text-xs">
              <span className="text-red-600 dark:text-red-400">+</span>{" "}
              METHODOLOGY
            </div>
            <p className="mt-2 text-gray-700 dark:text-gray-300 normal-case tracking-normal text-xs leading-relaxed font-sans font-medium">
              Are you passionate about sharing your thoughts, experiences, and
              expertise with the world? Look no further! Blogshog is your
              ultimate destination for creating and publishing your own blogs
              with ease.
            </p>
          </div>
        </div>
        {/* Right Side */}
        <div className="w-full md:w-3/4 p-8 md:p-16 flex flex-col relative overflow-hidden bg-white dark:bg-black">
          <div className="w-full border-b-2 border-black dark:border-white/30 pb-8 mb-16 text-center">
            <span className="text-[10px] font-mono uppercase tracking-widest font-bold bg-[#f4f4f4] dark:bg-[#111] px-4 py-2 border border-black dark:border-white/30 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
              Enhance Your Online Presence
            </span>
          </div>

          <h3 className="text-3xl md:text-4xl font-medium text-center uppercase tracking-normal max-w-5xl leading-[0.9] mb-20 text-black dark:text-white">
            Craft visually appealing and engaging blogs using our intuitive and
            user-friendly editor.
          </h3>

          <div className="flex flex-col sm:flex-row gap-6">
            <div className="mt-auto border-2 border-black dark:border-white/30 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)] flex flex-col lg:flex-row overflow-hidden relative">
              <div className="w-full border-b lg:border-b-0 lg:border-r-2 border-black dark:border-white/30 p-8 flex gap-4 justify-center dark:bg-[#0a0a0a] relative z-10">
                <div>
                  <span className="text-xs font-mono uppercase font-black tracking-widest text-black dark:text-white bg-[#f4f4f4] dark:bg-[#111] px-4 py-2 border border-black dark:border-white/30 inline-block shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
                    Reach a Global Audience
                  </span>

                  <p className="mt-4 text-gray-700 dark:text-gray-300 normal-case tracking-normal text-xs sm:text-sm leading-relaxed font-sans font-medium">
                    Share your stories, ideas, and insights with a worldwide
                    audience. Connect with readers from different backgrounds
                    and cultures who are eager to discover your content.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-auto border-2 border-black dark:border-white/30 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)] flex flex-col lg:flex-row overflow-hidden relative">
              <div className="w-full border-b lg:border-b-0 lg:border-r-2 border-black dark:border-white/30 p-8 flex gap-4 justify-center dark:bg-[#0a0a0a] relative z-10">
                <div>
                  <span className="text-xs font-mono uppercase font-black tracking-widest text-black dark:text-white bg-[#f4f4f4] dark:bg-[#111] px-4 py-2 border border-black dark:border-white/30 inline-block shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
                    Enhance Your Online Presence
                  </span>

                  <p className="mt-4 text-gray-700 dark:text-gray-300 normal-case tracking-normal text-xs sm:text-sm leading-relaxed font-sans font-medium">
                    Whether you're a seasoned Blogger or just starting out,
                    Blogshog helps you establish your online identity. Build
                    your personal brand and become a trusted voice in your
                    niche.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute top-8 right-8 hidden xl:flex">
            <Link
              to="/blogs/create"
              className="w-24 h-24 rounded-full border-2 border-black dark:border-white/30 bg-[#f4f4f4] dark:bg-[#111] flex items-center justify-center text-[10px] uppercase font-bold font-mono tracking-widest text-center hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] text-black dark:text-white"
            >
              START
              <br />
              WRITING
            </Link>
          </div>
        </div>
      </section>

      {/* WE CONSTRUCT TEXT BAND WITH POPPING IMAGE */}
      <section className="relative w-full h-48 sm:h-72 flex flex-col justify-center overflow-hidden bg-white dark:bg-black my-10">
        <div className="absolute inset-0 flex items-center justify-center border-y border-black dark:border-white/30 top-1/2 -translate-y-1/2 h-1/2 w-full z-0 overflow-hidden whitespace-nowrap bg-[#f4f4f4] dark:bg-[#111]">
          <h2 className="text-[10vw] sm:text-[7vw] font-black uppercase tracking-tighter leading-none px-4 text-black dark:text-white text-center">
            WE CONSTRUCT{" "}
            <span
              className="text-transparent"
              style={{ WebkitTextStroke: "2px gray" }}
            >
              CREATIVE
            </span>{" "}
            EXPRESSIONS
          </h2>
        </div>
        <Link
          to="/blogs"
          className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-28 sm:w-40 aspect-[3/4] border-2 border-black dark:border-white/30 bg-white dark:bg-black p-1 z-10 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)] hover:scale-105 transition-transform duration-500 cursor-pointer flex flex-col items-center"
        >
          <img
            src="https://images.unsplash.com/photo-1673445354464-4dbd41e0ad89?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            className="w-full flex-grow object-cover grayscale hover:grayscale-0 contrast-125 mb-1 border border-black dark:border-white/30"
            alt="Inset"
          />
          <div className="w-full text-center text-[10px] font-mono uppercase font-bold py-1 border-t-2 border-black dark:border-white/30 bg-[#f4f4f4] dark:bg-[#111] hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors">
            View All
          </div>
        </Link>
      </section>

      <Footer />
    </main>
  );
};

export default Home;
